import { createReducer, on } from '@ngrx/store';
import { AuthActions, AuthApiActions } from './auth.action';
import { User } from '../models/user';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState {
  loading?: boolean;
  user?: User;
  error?: string;
  isAuth: boolean;
}

export const initialState: AuthState = {
  loading: false,
  user: undefined,
  error: undefined,
  isAuth: false
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.login,
    (_state) => { return { ..._state, user: undefined, loading: true } }),  
  on(AuthActions.loginProcess,
      (_state) => { return { ..._state, loading: true, user: undefined } }),
  on(AuthActions.loginSucess,
    (_state, {user}) => { return { ..._state, loading: true, error: undefined, user: user, isAuth: false } }),
  on(AuthActions.initLoginInProgress,
    (_state) => { return { ..._state, loading: true, user: undefined } }),
  on(AuthActions.loginProgress,
    (_state, {user}) => { return { ..._state, loading: true, error: undefined, user: user, isAuth: false } }),
  on(AuthActions.loginProgressNoAuth,
    (_state) => { return { ..._state, loading: false, user: undefined } }),
  on(AuthActions.loginFail,
    (_state, {error}) => { return { ..._state, loading: false, error: error, user: undefined } }),
  on(AuthActions.logout,
    (_state) => { return { ..._state, ...initialState } }),
  on(AuthApiActions.loadUserPoliciesSuccess,
    (_state, {policies}) => { return { ..._state, loading: false, error: undefined, user: { ..._state.user!, policies}, isAuth: true } }),
);